import { useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useRoleCan } from '~/hooks';
import { setarStatusLidoAnnouncement } from '~/services/Announcements';
import { AnnouncementDialog } from '~/components/AnnouncementDialog';
import { useAnnouncementsPriority } from '~/hooks/useAnnouncements';

export const AnnouncementControl: React.VFC = () => {
  const userIsAdmin = useRoleCan({ roles: ['administrador'] });
  const {
    isOpen: isOpenModal,
    onOpen: onOpenModal,
    onClose: onCloseModal,
  } = useDisclosure();

  const { data, isLoading, refetch, isPreviousData } =
    useAnnouncementsPriority();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!!data && !isPreviousData) {
      onOpenModal();
    }
  }, [data]);

  const setCienciaCliente = () => {
    if (!data?.id) {
      return;
    }
    setIsFetching(true);
    setarStatusLidoAnnouncement(data.id)
      .then(() => {
        onCloseModal();
        refetch();
      })
      .catch(() => null)
      .finally(() => setIsFetching(false));
  };

  if (userIsAdmin || !data || !data.id) {
    return null;
  }

  return (
    <AnnouncementDialog
      isOpenModal={isOpenModal}
      onCloseModal={onCloseModal}
      status={data!.status_cliente}
      exigirCiencia={data!.exigir_ciencia}
      motivoCancelamento={data!.motivo_cancelamento}
      dataPublicacao={data!.formattedDate!}
      titulo={data!.titulo}
      mensagem={data!.mensagem}
      arquivos={data!.arquivos}
      setarStatusLido={setCienciaCliente}
      isFetching={isFetching}
    />
  );
};
